import _ from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { ReceivementState } from './ReceivementTypes'

const selectFeature = (state: State) => state.receivement

export const selectOnlyDivergents = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.onlyDivergents,
)

export const selectProductDescription = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.productDescription,
)

export const selectSortBy = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters.sortBy,
)

export const selectOverviewFilters = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overviewFilters,
)

export const selectOverview = createSelector(
  selectFeature,
  (state: ReceivementState) => state.overview,
)

export const selectSalesOverview = createSelector(
  selectFeature,
  (state: ReceivementState) => state.salesOverview,
)

export const selectSalesAwaitStatus = createSelector(
  selectFeature,
  (state: ReceivementState) => state.awaitStatus,
)

export const selectSalesHasProducts = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batchesStateByBatchItemOrderIds ? Object.keys(state.batchesStateByBatchItemOrderIds).length > 0 : false),
)

export const selectSalesHasErrors = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batchErrorIds.length > 0),
)

export const selectFirstObservationPosition = createSelector(
  selectFeature,
  (state: ReceivementState) => {
    const positionToGo = Object.values(state.observationsPositionByModelId)
      .filter((position) => !Number.isNaN(position))
      .sort((a, b) => a - b)
    return _.first(positionToGo) || Number.NaN
  },
)

export const selectObservationsPositionByModelId = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.observationsPositionByModelId),
)

export const selectBatches = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.batches),
)

export const selectDirectGondolaPrintLimit = createSelector(
  selectFeature,
  (state: ReceivementState) => (state.directGondolaPrintLimit),
)
